import React from 'react';
import { CheckCircle } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-white py-8 md:py-12 px-4 overflow-hidden" data-id="element-58">
      <div className="max-w-3xl mx-auto text-center" data-id="element-59">
        <p className="text-gray-600 font-semibold mb-2 uppercase tracking-wider text-sm" data-id="element-60">
          📚 Para padres y docentes de primaria
        </p>

        <h1 className="text-3xl md:text-5xl font-black text-gray-900 mb-2 leading-tight font-['Oswald'] uppercase" data-id="element-61">
          El Asombroso Viaje por el{' '}
          <span className="text-[#2980b9]" data-id="element-62">Cuerpo Humano</span>
        </h1>

        <p className="text-lg md:text-xl text-gray-600 mb-4 font-medium" data-id="element-63">
          Descubre cómo funciona el cuerpo… de forma simple y divertida
        </p>

        <a href="#compra" className="mb-6 relative group cursor-pointer block" data-id="element-64">
          <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-lg blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200" data-id="element-65"></div>
          <img src="https://cdn.magicpatterns.com/uploads/saYUTDYpN8fr6GUJP11rvk/mockup_guia_educativa_para_ninos.png" alt="Guía Educativa para Niños - Cuerpo Humano" className="relative mx-auto w-full max-w-sm transform transition hover:scale-105 duration-300" data-id="element-66" />
        </a>

        <div className="flex flex-col items-center gap-3" data-id="element-67">
          <a href="#compra" className="bg-[#22c55e] hover:bg-[#16a34a] text-white text-lg md:text-xl font-black py-4 px-6 md:px-10 rounded-lg shadow-[0_4px_0_#15803d] active:shadow-[0_2px_0_#15803d] active:translate-y-1 transition-all w-full max-w-md uppercase flex items-center justify-center gap-2 animate-pulse no-underline" data-id="element-68">
            🚀 Quiero acceder ahora
          </a>

          <div className="flex items-center gap-2 text-gray-600 font-semibold text-sm" data-id="element-69">
            <CheckCircle className="w-4 h-4 text-green-500" data-id="element-70" />
            <span data-id="element-71">🔒 Compra segura · Acceso inmediato</span>
          </div>
        </div>
      </div>
    </section>;
}